import StudentEducationBackground from "./src/main";
/* istanbul ignore next */
StudentEducationBackground.install = function (Vue) {
  Vue.component(StudentEducationBackground.name, StudentEducationBackground);
};

export default StudentEducationBackground;